import { Box, Skeleton, TableCell, TableRow } from '@mui/material';
import React from 'react';

interface TransactionTableSkeletonProps {
    rowCount?: number;
}

const TransactionTableSkeleton: React.FC<TransactionTableSkeletonProps> = ({ rowCount = 5 }) => {
    return (
        <>
            {Array.from({ length: rowCount }).map((_, index) => (
                <TableRow
                    key={index}
                    sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                    }}
                >
                    <TableCell padding="checkbox">
                        <Skeleton variant="rectangular" width={20} height={20} />
                    </TableCell>
                    <TableCell>
                        <Skeleton variant="text" width={100} />
                    </TableCell>
                    <TableCell>
                        <Skeleton variant="text" width={120} />
                    </TableCell>
                    <TableCell>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Skeleton variant="rectangular" width={24} height={24} sx={{ borderRadius: 1 }} />
                            <Skeleton variant="text" width={80} />
                        </Box>
                    </TableCell>
                    <TableCell>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                            <Skeleton variant="text" width={200} />
                            <Skeleton variant="text" width={160} />
                        </Box>
                    </TableCell>
                    <TableCell align="right">
                        <Skeleton variant="text" width={100} />
                    </TableCell>
                    <TableCell align="right">
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                            <Skeleton variant="circular" width={32} height={32} />
                            <Skeleton variant="circular" width={32} height={32} />
                        </Box>
                    </TableCell>
                </TableRow>
            ))}
        </>
    );
};

export default TransactionTableSkeleton;
